import {
  Divider,
  Modal,
  ModalContent,
  ModalOverlay,
  UseDisclosureReturn,
} from "@chakra-ui/react";
import { OrderGroup } from "enums";
import { ChartNotesModalBody, ChartNotesModalHeader } from "modules";
import { useOrderChartNotes } from "modules/charts-shared/api";
import * as React from "react";
import { OrderChartNote } from "./OrderChartNote";
import { OrderChartNoteModalFooter } from "./OrderChartNoteModalFooter";

type OrderChartNotesModalProps = {
  title: React.ReactNode;
  encounterId: string;
  chartCode: string;
  orderType: OrderGroup;
} & Pick<UseDisclosureReturn, "isOpen" | "onClose">;

function OrderChartNotesModal(props: OrderChartNotesModalProps) {
  const { isOpen, onClose, title, encounterId, chartCode, orderType } = props;

  const modalBodyRef = React.useRef<HTMLDivElement>(null);

  const scrollToBottom = React.useCallback(() => {
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTo({ top: modalBodyRef.current.scrollHeight });
    }
  }, []);

  const { data, isLoading } = useOrderChartNotes({
    encounterId,
    chartCode,
    orderType,
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        display="flex"
        flexDirection="column"
        height="500px"
        width="540px"
        maxWidth="540px"
        bg="white"
      >
        <ChartNotesModalHeader onClose={onClose} title={title} />
        <Divider />
        <ChartNotesModalBody isLoading={isLoading} ref={modalBodyRef}>
          {data?.data.map((note) => (
            <OrderChartNote
              key={note.id}
              note={note}
              orderGroup={orderType}
              chartCode={chartCode}
              encounterId={encounterId}
            />
          ))}
        </ChartNotesModalBody>
        <Divider />
        <OrderChartNoteModalFooter
          encounterId={encounterId}
          chartCode={chartCode}
          orderType={orderType}
          onCreateNoteSuccess={scrollToBottom}
        />
      </ModalContent>
    </Modal>
  );
}

export { OrderChartNotesModal };
